module.exports = __webpack_public_path__ + "static/img/hair_02.dee87e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_02.png
// module id = 2cd6
// module chunks = 0